import { contentApi } from './content.api';

/**
 * Injected into `contentApi` rather than a second `createApi` — same cache,
 * same envelope unwrap, same bearer token. This is a different backend service
 * from `content.api.ts`, but it answers on the same shared HTTP API, so it is
 * one more endpoint on the one slice rather than a second reducer for it.
 */

export type PluginManifest = { version: string; sha256: string; released: string };

const pluginsApi = contentApi.injectEndpoints({
  endpoints: (builder) => ({
    /** The current release's version and checksum — the unauthenticated route. */
    getLatestPluginRelease: builder.query<PluginManifest, void>({
      query: () => '/plugins/latest',
    }),
  }),
});

export const { useGetLatestPluginReleaseQuery } = pluginsApi;
